import "./sellscreendialogs.scss";
import { type FC, useState } from "react";
import { type ShopfrontDispatch, useShopfrontDispatch } from "../../../_Bootstrap/hooks";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import { addProductToSale, type SaleAddProductOptions } from "../../../Actions/SellScreen/SellScreenProductActions";
import Button from "../../../Common/Buttons/Button";
import PopupManager from "../../../Common/Popups/PopupManager";
import TouchNumbers from "../../../Common/TouchNumbers/TouchNumbers";

interface Props {
    uuid: string;
    name: string;
    options: SaleAddProductOptions;
    dispatch?: ShopfrontDispatch;
}

export const RequestQuantity: FC<Props> = ({ uuid, name, options, dispatch: overrideDispatch }) => {
    const [ value, setValue ] = useState<string>("");

    let dispatch = useShopfrontDispatch();

    if(overrideDispatch) {
        dispatch = overrideDispatch;
    }

    const addProduct = (keyboard = false): void => {
        let quantity = parseFloat(value);

        if(isNaN(quantity) || quantity === 0) {
            PopupManager.error("Please specify a quantity");

            return;
        } else if(quantity < 0) {
            PopupManager.error("Negative quantities are invalid");

            return;
        } else if(quantity >= 10000) {
            quantity = 9999;
        }

        if(keyboard && quantity >= 1000) {
            PopupManager.warning("Please press the \"Add\" add button for quantities of 1000 or higher");

            return;
        }

        if(typeof options.barcodeQuantity === "number") {
            quantity *= options.barcodeQuantity;
        }

        dispatch(hideDialog());
        dispatch(
            addProductToSale(uuid, {
                ...options,
                quantity,
            })
        );
    };

    const barcodeQuantity = options.barcodeQuantity || 1;

    return (
        <div className="request-quantity">
            <p>Please enter the quantity for {name}</p>
            {barcodeQuantity !== 1 && (
                <p>
                    This will be multiplied by the barcode quantity ({barcodeQuantity})
                </p>
            )}
            <TouchNumbers
                static
                hideConfirm
                bounds={{
                    min: 0,
                    max: 9999,
                }}
                input="normal"
                value={value}
                onChange={setValue}
                onConfirm={() => addProduct(true)}
                autoFocus
            />
            <div className="buttons">
                <Button
                    type="button"
                    classes={[ "cancel-button", "button-cancel" ]}
                    onClick={() => dispatch(hideDialog())}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    classes={[ "add-button", "button-primary" ]}
                    onClick={() => addProduct()}
                >
                    Add
                </Button>
            </div>
        </div>
    );
};
